import React, { useState } from "react";
import { X } from "lucide-react";
import { whatsappPhone } from "@/lib/whatsapp";

export const inputCls = "w-full rounded-xl border border-[#e6e2d8] bg-white px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#3E6A56]/30";
export const btnCls = "inline-flex items-center justify-center gap-2 rounded-xl bg-[#3E6A56] hover:bg-[#2D4F40] text-white px-4 py-2.5 text-sm font-medium transition disabled:opacity-50";
export const btnGhost = "inline-flex items-center justify-center gap-2 rounded-xl border border-[#e6e2d8] bg-white hover:bg-[#F9F8F6] text-[#1A201C] px-4 py-2.5 text-sm transition disabled:opacity-50";
export const waNumber = (phone) => whatsappPhone(phone);

export function Card({ title, actions, children, className = "" }) {
  return (
    <section className={`bg-white rounded-2xl border border-[#e6e2d8] shadow-sm ${className}`}>
      {(title || actions) && (
        <div className="flex flex-wrap items-center justify-between gap-3 px-5 py-4 border-b border-[#e6e2d8]">
          <h3 className="font-bold text-[#1A201C]" style={{ fontFamily: "IBM Plex Sans Arabic" }}>{title}</h3>
          <div className="flex flex-wrap items-center gap-2">{actions}</div>
        </div>
      )}
      <div className="p-5">{children}</div>
    </section>
  );
}

export function Pill({ className = "", children }) {
  return <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-medium ${className}`}>{children}</span>;
}

export function StatCard({ label, value, tone = "text-[#3E6A56]" }) {
  return (
    <div className="bg-white rounded-2xl border border-[#e6e2d8] p-5">
      <div className="text-sm text-[#4A554E]">{label}</div>
      <div className={`text-3xl font-bold mt-1 ${tone}`}>{value}</div>
    </div>
  );
}

export function Modal({ title, onClose, children, wide = false }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-start justify-center p-4 overflow-y-auto" dir="rtl">
      <div className={`bg-white rounded-2xl w-full ${wide ? "max-w-4xl" : "max-w-lg"} my-8`}>
        <div className="no-print flex items-center justify-between px-5 py-4 border-b border-[#e6e2d8]">
          <h3 className="font-bold">{title}</h3>
          <button type="button" onClick={onClose} aria-label="إغلاق"><X className="w-5 h-5" /></button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <label className="block">
      <span className="block text-sm text-[#1A201C] mb-1.5">{label}</span>
      {children}
    </label>
  );
}

export function Empty({ children }) {
  return <div className="text-center text-[#4A554E] py-10 text-sm">{children ?? "لا توجد بيانات"}</div>;
}

// اختيار طالب من سجلات المرشد: بحث بالاسم أو الصف، وتُغلق القائمة بعد الاختيار
export function StudentPicker({ students, value, onChange }) {
  const [grade, setGrade] = useState("");
  const [q, setQ] = useState("");
  const chosen = students.find((s) => s.id === value);
  if (chosen) {
    return (
      <div className="rounded-xl bg-[#e8f0ec] border border-[#3E6A56] px-3 py-2 text-sm flex justify-between items-center gap-2">
        <span>الطالب المختار: <b>{chosen.name}</b> <span className="text-xs">{chosen.grade}</span></span>
        <button type="button" className="text-xs underline" onClick={() => { onChange(""); setQ(""); }}>تغيير</button>
      </div>
    );
  }
  const grades = [...new Set(students.map((s) => String(s.grade || "").trim() || "بدون صف"))].sort((a, b) => a.localeCompare(b, "ar", { numeric: true }));
  const inGrade = students.filter((s) => (String(s.grade || "").trim() || "بدون صف") === grade);
  const term = q.trim();
  const list = (term ? inGrade.filter((s) => s.name.includes(term)) : inGrade).sort((a, b) => a.name.localeCompare(b.name, "ar"));
  return (
    <div className="space-y-2">
      <select className={inputCls} value={grade} onChange={(e) => { setGrade(e.target.value); setQ(""); }} data-testid="fu-grade-select">
        <option value="">١) اختر الصف</option>
        {grades.map((g) => <option key={g} value={g}>{g}</option>)}
      </select>
      {grade && (
        <>
          <input className={inputCls} value={q} onChange={(e) => setQ(e.target.value)} placeholder="بحث بالاسم داخل هذا الصف (اختياري)" data-testid="fu-student-search" />
          {list.length === 0 && <div className="text-xs text-[#4A554E]">لا يوجد طالب مطابق في هذا الصف.</div>}
          <div className="border border-[#e6e2d8] rounded-xl max-h-56 overflow-y-auto divide-y divide-[#f0ede4]">
            {list.map((s) => (
              <button type="button" key={s.id} className="w-full text-start px-3 py-2 text-sm hover:bg-[#F9F8F6]" onClick={() => { onChange(s.id); setQ(""); }}>
                {s.name}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
